var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _c("div", [
        _c(
          "a",
          {
            staticClass:
              "btn btn-outline-white text-white btn-default waves-effect waves-light position-absolute m-05",
            attrs: { href: _vm.previous_page },
          },
          [
            _c("i", { staticClass: "feather icon-arrow-left" }),
            _vm._v(
              "\n                " +
                _vm._s(_vm.__("event.form.buttons.back")) +
                "\n            "
            ),
          ]
        ),
        _vm._v(" "),
        _c("img", {
          staticClass: "card-img-top img-fluid",
          staticStyle: { "object-fit": "cover" },
          attrs: {
            src:
              _vm.event.event_image == null
                ? "/images/cover.png"
                : _vm.event.event_image.url,
            alt: "Event Image",
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-content" }, [
        _c("div", { staticClass: "card-body pb-05" }, [
          _c("div", { staticClass: "d-flex justify-content-between mb-05" }, [
            _c("div", [
              _c("h1", {
                staticClass: "font-large-1 mb-05",
                domProps: { textContent: _vm._s(_vm.event.title) },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "font-medium-3 primary mb-0" }, [
                _c("i", { staticClass: "fa fa-calendar" }),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.event.event_start_end_date),
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-05" }, [
              _vm.event.access === "Offline Event"
                ? _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill bg-gradient-secondary d-block mb-05 text-bold-700 font-small-2 ",
                    },
                    [
                      _c("i", { staticClass: "feather icon-user-plus" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("event.cards.offline")) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.event.access === "Online Event"
                ? _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill badge-success d-block mb-05 text-bold-700 font-small-2 ",
                    },
                    [
                      _c("i", { staticClass: "feather icon-globe" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("event.cards.online")) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.event.access === "Hybrid Event"
                ? _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill badge-warning d-block mb-05 text-bold-700 font-small-2 ",
                    },
                    [
                      _c("i", { staticClass: "feather icon-calendar" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("event.cards.hybrid")) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              this.sold_out === true
                ? _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill badge-danger d-block mb-05 font-small-2 text-bold-700",
                    },
                    [
                      _c("i", { staticClass: "feather icon-alert-circle" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("event.sold_out")) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.event.event_privacy === 1
                ? _c(
                    "span",
                    {
                      staticClass:
                        "badge badge-pill  d-block mb-05 font-small-2 text-bold-700",
                    },
                    [
                      _c("i", { staticClass: "feather icon-award" }),
                      _vm._v(
                        "  " +
                          _vm._s(_vm.__("event.cards.premium")) +
                          "\n                        "
                      ),
                    ]
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "card-text mt-05 pr-1 text-muted" }, [
            _c("i", { staticClass: "fa fa-map-marker" }),
            _vm._v(" " + _vm._s(_vm.event.location) + " | "),
            _c("i", { staticClass: "fa fa-map-pin" }),
            _vm._v(" " + _vm._s(_vm.event.venue) + "\n                "),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "pt-1 pb-1 border-top mt-1" }, [
            _c("span", {
              staticClass: "breakAll image-resize",
              domProps: { innerHTML: _vm._s(_vm.event.event_description) },
            }),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "d-flex align-items-center border-top" }, [
            _c("div", { staticClass: "pr-1 pt-1 pb-1 pl-0" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.event.contact_name,
                      expression: "event.contact_name",
                    },
                  ],
                  staticClass: "user-name text-bold-600",
                },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.__("globals.contact_name")) +
                      "\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(_vm._s(_vm.event.contact_name) + "\n                    "),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-1" }, [
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.event.contact_phone,
                      expression: "event.contact_phone",
                    },
                  ],
                  staticClass: "user-name text-bold-600",
                },
                [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.__("globals.contact_phone")) +
                      "\n                        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c("br"),
              _vm._v(
                _vm._s(_vm.event.contact_phone) + "\n                    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.event.contact_email,
                    expression: "event.contact_email",
                  },
                ],
                staticClass: "p-1",
              },
              [
                _c("span", { staticClass: "user-name text-bold-600" }, [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.__("globals.contact_email")) +
                      "\n                        "
                  ),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(
                  _vm._s(_vm.event.contact_email) + "\n                    "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _vm.event.tickets.length > 0 || _vm.event.contact_link !== null
            ? _c(
                "div",
                { staticClass: "d-flex align-items-center border-top" },
                [
                  _vm.event.tickets.length > 0 && this.sold_out !== true
                    ? _c("div", [
                        _vm._v(
                          "\n                        " +
                            _vm._s(_vm.__("globals.from")) +
                            " " +
                            _vm._s(
                              _vm._f("currency")(this.price, _vm.site_tax)
                            ) +
                            "\n                    "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "d-flex flex-row-reverse ml-auto mt-1 mb-05",
                    },
                    [
                      _vm.event.tickets.length > 0 &&
                      !this.sold_out &&
                      _vm.guestPurchaseTickets === 1
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn btn-primary waves-effect waves-light",
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.buyTickets.apply(null, arguments)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(
                                      _vm.__("event.form.buttons.buy_tickets")
                                    ) +
                                    " "
                                ),
                                _c("i", { staticClass: "fa fa-tag" }),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.event.contact_link !== null
                        ? _c("div", { staticClass: "mr-05" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.event.contact_link,
                                  target: "_blank",
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary waves-effect waves-light pl-1 pr-1",
                                  },
                                  [
                                    _vm._v(
                                      "\n                                    " +
                                        _vm._s(
                                          _vm.__(
                                            "event.form.buttons.view_event_site"
                                          )
                                        ) +
                                        "\n                                    "
                                    ),
                                    _c("i", {
                                      staticClass: "feather icon-chevron-right",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "d-flex justify-content-between border-top pl-05 pr-05",
        },
        [
          _c("div", { staticClass: "p-05" }, [
            _c("i", {
              staticClass: "fa fa-thumbs-o-up",
              attrs: {
                "data-toggle": "modal",
                "data-target": "#registerModal",
              },
            }),
            _vm._v(
              "\n                 " +
                _vm._s(_vm.event.likesCount === 0 ? "" : _vm.event.likesCount) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "p-05" }, [
            _c(
              "span",
              {
                attrs: {
                  "data-toggle": "modal",
                  "data-target": "#registerModal",
                },
              },
              [
                _c("i", { staticClass: "fa fa-comment-o" }),
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.event.commentsCount === 0
                        ? ""
                        : _vm.event.commentsCount
                    ) +
                    "\n                    " +
                    _vm._s(
                      _vm.event.commentsCount === 1
                        ? _vm.__("globals.comment")
                        : _vm.__("globals.comments")
                    ) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [_c("guest-social-share", { attrs: { social: _vm.event.social } })],
            1
          ),
        ]
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "registerUserModal",
          tabindex: "-1",
          role: "dialog",
          "aria-labelledby": "registerUserModalLabel",
          "aria-hidden": "true",
          "data-backdrop": "static",
          "data-keyboard": "false",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog", attrs: { role: "document" } },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c("div", { staticClass: "modal-header" }, [
                _c(
                  "h5",
                  {
                    staticClass: "modal-title",
                    attrs: { id: "registerUserModalLabel" },
                  },
                  [_vm._v(_vm._s(_vm.__("globals.your_details")))]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "close",
                    attrs: {
                      type: "button",
                      "data-dismiss": "modal",
                      "aria-label": "Close",
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.closeModal()
                      },
                    },
                  },
                  [
                    _c("span", { attrs: { "aria-hidden": "true" } }, [
                      _vm._v("×"),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("form", { attrs: { id: "registerForm" } }, [
                _c("div", { staticClass: "modal-body" }, [
                  _vm.errorMessage
                    ? _c(
                        "div",
                        {
                          staticClass: "text-center text-danger help-block",
                          attrs: { role: "alert" },
                        },
                        [
                          _c("i", { staticClass: "feather icon-x-circle" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.errorMessage) +
                              "\n                        "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "first_name" } },
                      [_vm._v(_vm._s(_vm.__("user.field.text.first_name")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.first_name,
                          expression: "first_name",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "first_name",
                        id: "first_name",
                      },
                      domProps: { value: _vm.first_name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.first_name = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.first_name
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-left text-danger help-block font-small-1",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("i", { staticClass: "feather icon-x-circle" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.errors.first_name[0]) +
                                "\n                            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "last_name" } },
                      [_vm._v(_vm._s(_vm.__("user.field.text.last_name")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.last_name,
                          expression: "last_name",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "last_name",
                        id: "last_name",
                      },
                      domProps: { value: _vm.last_name },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.last_name = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.last_name
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-left text-danger help-block font-small-1",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("i", { staticClass: "feather icon-x-circle" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.errors.last_name[0]) +
                                "\n                            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group" }, [
                    _c(
                      "label",
                      { staticClass: "required", attrs: { for: "email" } },
                      [_vm._v(_vm._s(_vm.__("user.field.text.email")))]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email",
                        },
                      ],
                      staticClass: "form-control",
                      attrs: { type: "text", name: "email", id: "email" },
                      domProps: { value: _vm.email },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _vm.errors.email
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "text-left text-danger help-block font-small-1",
                            attrs: { role: "alert" },
                          },
                          [
                            _c("i", { staticClass: "feather icon-x-circle" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.errors.email[0]) +
                                "\n                            "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _vm._v(" "),
                  _vm.allow_registration
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "vs-checkbox-con vs-checkbox-primary",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.create_account,
                                      expression: "create_account",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    name: "create_account",
                                    id: "create_account",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.create_account)
                                      ? _vm._i(_vm.create_account, null) > -1
                                      : _vm.create_account,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.create_account,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.create_account = $$a.concat([
                                              $$v,
                                            ]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.create_account = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.create_account = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm._m(0),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "font-small-3" }, [
                              _c(
                                "label",
                                { attrs: { for: "create_account" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.__("user.create_member_account"))
                                  ),
                                ]
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.create_account
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "vs-checkbox-con vs-checkbox-primary",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.terms,
                                      expression: "terms",
                                    },
                                  ],
                                  attrs: {
                                    type: "checkbox",
                                    name: "accepted_terms_and_conditions",
                                    id: "accepted_terms_and_conditions",
                                  },
                                  domProps: {
                                    checked: Array.isArray(_vm.terms)
                                      ? _vm._i(_vm.terms, null) > -1
                                      : _vm.terms,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.terms,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.terms = $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.terms = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.terms = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _vm._m(1),
                              ]
                            ),
                            _vm._v(" "),
                            _c("span", { staticClass: "font-small-3" }, [
                              _c("label", {
                                attrs: { for: "accepted_terms_and_conditions" },
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.__(
                                      "globals.accept_terms_and_privacy_policy"
                                    )
                                  ),
                                },
                              }),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.errors.terms
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-left text-danger help-block font-small-1",
                                attrs: { role: "alert" },
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-x-circle",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.errors.terms[0]) +
                                    "\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.create_account
                    ? _c("div", { staticClass: "form-group" }, [
                        _c(
                          "label",
                          {
                            staticClass: "required",
                            attrs: { for: "password" },
                          },
                          [_vm._v(_vm._s(_vm.__("user.field.text.password")))]
                        ),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.password,
                              expression: "password",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: {
                            type: "password",
                            name: "password",
                            id: "password",
                          },
                          domProps: { value: _vm.password },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.password = $event.target.value
                            },
                          },
                        }),
                        _vm._v(" "),
                        _vm.errors.password
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "text-left text-danger help-block font-small-1",
                                attrs: { role: "alert" },
                              },
                              [
                                _c("i", {
                                  staticClass: "feather icon-x-circle",
                                }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.errors.password[0]) +
                                    "\n                            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("input", {
                    attrs: {
                      type: "hidden",
                      name: "recaptcha",
                      id: "recaptcha",
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "modal-footer" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.closeModal()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.__("globals.close")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.submitForm()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.__("event.select_tickets")))]
                    ),
                  ]),
                ]),
              ]),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "vs-checkbox" }, [
      _c("span", { staticClass: "vs-checkbox--check" }, [
        _c("i", { staticClass: "vs-icon feather icon-check" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "vs-checkbox" }, [
      _c("span", { staticClass: "vs-checkbox--check" }, [
        _c("i", { staticClass: "vs-icon feather icon-check" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }